import { render } from "./tbilisiMap.vue?vue&type=template&id=34610232"
const script = {}

import "./tbilisiMap.vue?vue&type=style&index=0&id=34610232&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__